<template>
    <template v-if="mode === 'table'">
        <div v-if="v!='null'">
            <p  class="text-truncate" style="max-width: 300px;">{{v}}

                <v-overlay
                    activator="parent"
                    location-strategy="connected"
                    scroll-strategy="reposition"
                >
                <v-card class="pa-2">{{v}}</v-card>
                </v-overlay>
            </p>
        </div>
    </template>

    <template v-else-if="mode === 'view'">
        <div v-if="v!='null'">
          <p style="white-space: pre-wrap;">  {{ v }} </p>
        </div>
    </template>

    <template v-else-if="mode === 'edit'">
        <v-textarea rows="2" :label=column.title variant="outlined" v-model="v" @input="handleInput"  placeholder="Input some text" />     
    </template>
    <template v-else>
        {{v}}
    </template>
    
</template>

<script>
//@input="handleInput" 
export default {
    name: 'text-widget',
    props:['mode','column', 'modelValue'],
    emits: ['update:modelValue'],
    data(){ 
        return {
            v: this.modelValue
        }
    },   

        mounted(){

            if (this.modelValue == '' || this.modelValue == undefined || this.modelValue == null || this.modelValue == 'null'||this.modelValue == 'NULL'){
            this.v = '';
            }
            else {
            this.v = String(this.modelValue);
            }
        },

    methods:{
        handleInput (e) {            
        let choosedvalue = '';
        if (e.target.value == '' || e.target.value == undefined || e.target.value == null){
            choosedvalue = null;
        }  
        else{
            choosedvalue = e.target.value;
        }
        this.$emit('update:modelValue', choosedvalue);
        if (choosedvalue == null){
            this.v = '';
        }  
        else{
            this.v = String(this.modelValue);
        }
        },

    },

    watch: {
        modelValue() {
            if (this.modelValue == null){
                this.v = '';
            }  
            else{
                this.v = String(this.modelValue);
            }
        },
    },

}
</script>
